@if (!isHomePage || searchProductModeSwitcherService.showSearchProduct()) {
  <div class="search-product">
    <sd-searchbox-container placeholder="поиск" type="modal" data-testid="product-search"></sd-searchbox-container>
  </div>
}
